import { Container } from 'react-bootstrap';

/**
 * Offline page for PWA
 *
 * Shows if the user is offline and we can't get the data from the cache.
 */
export default function OfflinePagePWA() {
  return (
    <Container className="pt-3">
      <h3>Internet connection lost</h3>
      <p>
        Sorry! The app needs an internet connection to get this page. Please
        check you have WiFi or 3G/4G/5G enabled.
      </p>
    </Container>
  );
}
